import {ethers} from 'ethers'

function initEthers(){



};

export default initEthers